import reducer from './reducers';

export { default as statsConfigActions } from './actionCreators';
export { default as statsConfigSagas } from './sagas';
export { default as statsConfigSelectors } from './selectors';

export default reducer;
